import { render, staticRenderFns } from "./ReviewsFullListController.vue?vue&type=template&id=38f90e76&scoped=true&"
import script from "./ReviewsFullListController.vue?vue&type=script&lang=ts&"
export * from "./ReviewsFullListController.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsFullListController.vue?vue&type=style&index=0&id=38f90e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f90e76",
  null
  
)

export default component.exports